import { Injectable } from '@angular/core';
import { TotalResultViewModel } from '../models/total-result-view-model';
import { CmsContentService } from './cms-content.service';

@Injectable({
  providedIn: 'root'
})
export class RiskimageService {

  constructor(private cmsContent: CmsContentService) { }

  getRiskLevelMeter(riskLevel: TotalResultViewModel | undefined): string {

    let img = "no-data.svg";
    switch (riskLevel?.risk) {
      case 1:
        if (riskLevel?.risk_id !== 1)
          img = "green.svg";
        break;
      case 2:
        img = "yellow-1.svg";
        break;
      case 3:
        img = "yellow-2.svg";
        break;
      case 4:
        img = "yellow-3.svg";
        break;
      case 5:
        img = "red-1.svg";
        break;
      case 6:
        img = "red-2.svg";
        break;
      case 7:
        img = "red-3.svg";
        break;
    }

    return this.cmsContent.getRiskLevelMeterImageUrl(img);
  }

  getImage(x: number): string {
    if (x < 0.25)
      return "Green.svg";
    if (x < 0.5)
      return "Yellow.svg";
    if (x < 0.75)
      return "Red.svg";
    return "No-Data.svg"
  }
}
